import {Partner, Location} from '@app/shared';

export interface BaseKeyValueItem {
  label: string;
  editable: boolean;
  noWrap?: boolean;
  required?: boolean;
  parentObject: any; // objeto en cuestion
  path: string; // string que refleje el path a la propiedad del objeto en cuestion
  component: string // Componente en el que se muestra para diferenciar entre distintas instancias del mismo
  hideLabel?: boolean;
  isLoadUnitTemplate?: boolean; // Como los LoadUnit y los LoadUnitTemplate poseen las mismas propiedades no se puede definir en la funcion detectInterfaceType
}

export interface TextKeyValueItem extends BaseKeyValueItem{
  type: 'text';
  numberValue?: boolean;
  value?: string;
}

export interface LinkKeyValueItem extends BaseKeyValueItem {
  type: 'link';
  value: {
    label?: string;
    url: string;
  };
}

export interface RouteKeyValueItem extends BaseKeyValueItem {
  type: 'route';
  list: Location[]; // Lista de rutas/lugares
  destinationPath?: string;
  value: {
    origin?: number;
    destination?: number;
  };
}

export interface DateKeyValueItem extends BaseKeyValueItem {
  type: 'date';
  endDatePath?: string;
  value: {
    startDate?: string;
    endDate?: string;
    format?: string;
    showHours?: boolean;
    showExpirationAlert?: boolean;
  };
}
export interface BadgeKeyValueItem extends BaseKeyValueItem {
  type: 'badge';
  list: any[];
  value: {
    state?: any;
  };
}

export interface SelectKeyValueItem extends BaseKeyValueItem {
  type: 'select';
  list: any[];
  selectLabel: string;
  short?: string;
  selectValue: string;
  value: any;
}

export interface BooleanKeyValueItem extends BaseKeyValueItem {
  type: 'boolean';
  icon?: string;
  trueColor?: string;
  falseColor?: string;
  value: boolean;
}

export interface AvatarKeyValueItem extends BaseKeyValueItem {
  type: 'avatar';
  list: any[];
  value: {
    userId?: number;
    alt?: string;
    size?: number;
    centered?: boolean;
    isGood?: boolean;
  };
}

export interface BtnKeyValueItem extends BaseKeyValueItem {
  type: 'btn';
  value: {
    label?: string;
    prefix?: string;
    localPrefix?: string;
    sufix: string;
    link?: string;
    isOdoo?: boolean;
    isRawLink?: boolean;
  };
}

/** Este tipo de datos no sera editable **/
export interface MoneyKeyValueItem extends BaseKeyValueItem {
  type: 'money';
  value: {
    number: number | undefined;
    iso: string;
  };
}


export type KeyValueItem =
  | TextKeyValueItem
  | LinkKeyValueItem
  | RouteKeyValueItem
  | DateKeyValueItem
  | AvatarKeyValueItem
  | BadgeKeyValueItem
  | SelectKeyValueItem
  | BooleanKeyValueItem
  | MoneyKeyValueItem
  | BtnKeyValueItem;

export interface KeyValueGroup {
  layout: 'normal' | 'collapse';
  dissabled?: boolean;
  name: string;
  items: KeyValueItem[];
}
